// src/components/InfoAnnouncement.js
import React, { useState } from 'react';
import styled from 'styled-components';

const InfoCardNewsContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 5% 15% 5% 15%;

  @media (max-width: 500px) {
    padding:5%;
  }
  


`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-top:5%;
  border-top: 1px solid #3F3F3F;
`;

const SectionTitle = styled.h2`
  
  color: #FFFFFF;
  font-weight: 700;
  font-size: 36px;
  line-height: 52px;
  letter-spacing: 0.05em;
  border-left:8px solid #FFF56A ;
  padding:0% 0% 0% 2.5%;


  @media (max-width: 500px) {
    font-weight: 700;
    font-size: 32px;
    line-height: 46px;
  }
  



`;

const CardSection = styled.div`
  display: grid;
  grid-template-areas: "card1 card2"; /* 定义两列，分别为 card1 和 card2 */
  gap: 40px; /* 列之间的间距 */
  overflow: hidden;

  @media (max-width: 500px) {
    grid-template-areas: ; 
    display: flex;
    flex-direction: column;
    width:100%;
    padding:0%;





`;

const Card = styled.div`
  background: #000000;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 36px;
  gap: 18px;
  color: #FFFFFF;

  
  transition: opacity 0.3s ease-in-out;

  &.card1 {
    grid-area: card1; /* 设置该卡片属于 card1 区域 */
  }

  &.card2 {
    grid-area: card2; /* 设置该卡片属于 card2 区域 */
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #AFAFAF;
    
  }


  h5 {
    color: #FFFFFF;
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 35px;
    display: flex;
    align-items: flex-start;
    margin-bottom:0px;
    margin-top:0px;
    


  }

  @media (max-width: 500px) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom:16px;
    align-items: flex-start;
    padding: 0px;
  
    h5 {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }

    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
    }


  }

`;

const Subtitle = styled.h3`
  color: #FFFFFF;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  display: flex;
  align-items: flex-start;
  margin-top:20px;
  

  @media (max-width: 500px) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom:16px;
    align-items: flex-start;
  }
`;

const ReadMoreButton = styled.button`
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin-left: auto;

  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    
    padding: 6px 20px;

    margin: 0 auto 0 0;

  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }


`;




const InfoAnnouncement = () => {





  return (
    <InfoCardNewsContainer>
      <SectionHeader>
        <SectionTitle>網站宣告</SectionTitle>
    
      </SectionHeader>
        <CardSection>
          <Card>
            {/* 卡片内容 */}
            
            <h5>網頁使用條款</h5>
            <p>本網站為數位發展部民主網絡司委辦，為利各界廣為利用網站資料，「次世代數位寶島成果展示網站」刊載之所有資料與素材除另有標示者，其得受著作權保護之範圍，採「公眾領域貢獻宣告」（CC0 1.0） 發布，授權予公眾自由取用。</p>
            <a href="https://www.plurality.moda.gov.tw/newstitleanddate/?id=1" target="_blank" style={{ textDecoration: 'none' }}>
            <ReadMoreButton>閱讀全文</ReadMoreButton>
            </a>
          </Card>
          <Card>
            {/* 卡片内容 */}
            <h5>隱私權及網站安全政策</h5>
            <p>歡迎瀏覽「次世代數位寶島成果展示網站」（以下簡稱本網站）， 為了幫助您瞭解本網站如何保護您在使用網站時的安全，及如何蒐集、應用及保護您所提供的個人資訊，請您務必詳細閱讀下列資訊：</p>
          
            <a href="https://www.plurality.moda.gov.tw/newstitleanddate/?id=1" target="_blank" style={{ textDecoration: 'none' }}>
            <ReadMoreButton>閱讀全文</ReadMoreButton>
            </a>
          </Card>
        </CardSection>
    </InfoCardNewsContainer>
  );
};

export default InfoAnnouncement;
